import { useRef, useEffect, useState, useCallback } from "react";
import { Text } from "@ds/react";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import deviceType from "utils/deviceType";
import * as S from "./Tooltip.style";

const Tooltip = ({ title, description, children }) => {
  const [show, setShow] = useState(false);
  const tooltipRef = useRef();

  const isMobile = deviceType() !== "desktop";

  const handleClose = useCallback(() => {
    setShow(false);
    if (!tooltipRef.current) {
      return false;
    }
  }, []);

  useEffect(() => {
    function closeTooltip() {
      handleClose();
    }
    document.addEventListener("click", closeTooltip);

    return () => {
      document.removeEventListener("click", closeTooltip);
    };
  }, [handleClose]);

  return (
    <S.TooltipContainer
      onClick={(event) => {
        if (!tooltipRef.current || show || !isMobile) {
          return;
        }
        const { innerWidth } = window;
        tooltipRef.current.style.width = `${innerWidth - 24}px`;
        tooltipRef.current.style.top = `50%`;
        tooltipRef.current.style.right = "0";
        tooltipRef.current.style.position = "absolute";
        tooltipRef.current.style.transform = "translateY(-115%)";
        event.stopPropagation();
        setShow(true);
      }}
      onMouseLeave={() => {
        if (isMobile) {
          return;
        }
        handleClose();
      }}
      onMouseEnter={(event) => {
        if (!tooltipRef.current || show || isMobile) {
          return;
        }
        const width = 370;
        tooltipRef.current.style.position = "absolute";
        tooltipRef.current.style.top = `0px`;
        tooltipRef.current.style.width = `${width}px`;
        tooltipRef.current.style.right = "0";
        tooltipRef.current.style.transform = "translateY(-105%)";
        event.stopPropagation();
        setShow(true);
      }}
    >
      <S.Tooltip
        show={show}
        ref={tooltipRef}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        {show && (
          <>
            <S.Header>
              <Text variant="body-01-sm">{title}</Text>
              <CloseIcon
                onClick={(event) => {
                  event.stopPropagation();
                  setShow(false);
                }}
              />
            </S.Header>
            <S.Content>
              <Text variant="body-01-sm">{description}</Text>
            </S.Content>
          </>
        )}
      </S.Tooltip>
      {children}
    </S.TooltipContainer>
  );
};

export default Tooltip;
